  <template>
  <div class="home">
    <div class="nav-header">
      <div class="container">
        <div class="nav">
          <router-link to="/">
            <div class="logo">
              <img src="@/assets/logo.png" alt="" />
              <div class="title">
                <h1>Health tracker</h1>
                <i class="iconfont icon-sousuo1x"></i>
              </div>
            </div>
          </router-link>
          <a href="#/" class="nav-item" @click="toggleActive('home')">
            <span :class="{ actived: activeClass == 'home' }">首页</span>
            <span class="sanjiao" v-if="activeClass == 'home'"></span>
          </a>
          <a href="#corp" class="nav-item" @click="toggleActive('corp')">
            <span :class="{ actived: activeClass == 'corp' }">公司</span>
            <!-- <span :class="{ actived: activeClass == 'intro' }">介绍</span> -->
            <!-- <span class="sanjiao" v-if="activeClass == 'intro'">Corporations</span> -->
            <!--  -->
          </a>
        </div>
      </div>
    </div>
    <div  class="app_content">
        <div >
          <div class="title">生命体征</div>
          <div class="sub_title">Attune的健康生物标志物</div>
          <div class="list"> 
            <div >
            <img src="@/assets/hrv.svg" alt="">
            <span>人力资源价值</span>
            <div>
              为一个人的健康和福祉提供有价值的见解，并可用于监测和改善整体心血管健康。
            </div>   
          </div>
          <div>
            <img src="@/assets/blood-pressure.svg" alt="">
            <span>血压</span>
            <div>
              是心血管健康的重要指标。血压升高是心脏病、中风或肾脏疾病的危险因素。
            </div>   
            <div class="tips">
              由于苹果的限制，我们只将此结果发送到您的电子邮件。
            </div>
          </div>  
          <div>
            <img src="@/assets/heart-rate.svg" alt="">
            <span>心率</span>
            <div>
              测量心率可以帮助识别异常情况，评估对体育锻炼的反应，并监测医疗效果。
            </div>   
          </div>

          <div>
            <img src="@/assets/breathing-rate.svg" alt="">
            <span>呼吸频率</span>
            <div>
              可以成为监测呼吸功能，评估健身水平和跟踪整体健康状况的重要工具。
            </div>   
          </div>
          <div>
            <img src="@/assets/prq.svg" alt="">
            <span>脉搏呼吸商（PRQ）</span>
            <div>
              为一个人的健康和福祉提供有价值的见解，并可用于监测和改善整体心血管健康。
            </div>   
          </div>
          <div>
            <img src="@/assets/oxygen-saturation.svg" alt="">
            <span>氧饱和度</span>
            <div>
              测量血液中的氧气含量，并有助于评估氧气输送到身体组织的效率。
            </div>   
          </div>
          </div>
         
          <!--
  -->
        </div>

    </div>
    <div class="home_icon">
      <img src="@/assets/logo.png" alt="" />
      <h4 style="font-weight: blod; font-size: 40px; margin-top: 20px">
        Health tracker
      </h4>
    </div>
    <div class="message">
      <div class="item">
        <h3>公司名称</h3>
        <p>莱斯时代（北京）科技有限公司</p>
      </div>
      <div class="item">
        <h3>公司地址</h3>
        <p>北京市朝阳区北苑路甲13号院2号楼16层2-1602</p>
      </div>
      <!-- <div class="item">
        <h3>商务合作</h3>
        <p>17710545460</p>
      </div> -->
      <!-- <div class="item">
        <h3>客服QQ</h3>
        <p>2118789460</p>
      </div> -->
      <!-- <div class="item">
        <div class="privacy" @click="goPrivacy">隐私政策</div>
      </div> -->
    </div>
    <div class="banquan">
      <span style="cursor: pointer" @click="jumpOther"
        >© 莱斯时代（北京）科技有限公司 | 京ICP备2022035200号-5A</span
      >
    </div>
    <!--<div class="" id="join">
      <div class="message">
        <div class="item">
          <h3>客服邮箱</h3>
          <p>sbgrceone@outlook.com</p>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
  export default {
    name: "home",
    components: {},
    data() {
      return {
        activeClass: "home",
      };
    },
    methods: {
      toggleActive(name) {
        this.activeClass = name;
      },
      goPrivacy() {
        this.$router.push("/privacy");
      },
      // 下载app
      downloadApp() {
        location.href = "";
      },
      jumpOther() {
        window.open("https://beian.miit.gov.cn/#/Integrated/index");
      },
    },
    mounted() {
      let _this = this;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  };
</script>
<style scoped lang="less">
  .home {
    .banquan {
      width: 100%;
      min-width: 1200px;
      height: 80px;
      color: #fff;
      line-height: 80px;
      // font-size: 24px;
      background: rgba(37, 42, 52, 1);
      text-align: center;
    }

    .app_content{
      width: 100%;
      width: 1200px;
      margin:120px auto;
      
      .title{
        font-size:24px;
        font-weight: 700;
        color:#000;
      }
      .sub_title{
        margin-top:5px;
        font-weight: 700;
        color:#a1a1a6!important;
      }
      // display: flex;
      // flex-direction: column;
      
      .list{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-wrap: wrap;
        &>div{
          width:calc(33.33% - 105px);
          padding-right:70px;
          margin-top:70px;
          &:nth-child(3n){
            padding-right:0;
          }
          &>span{
            display: block;
            font-size: 18px;
            line-height: 1.4;
            font-weight: 700;
            margin-top:20px;
          }
          &>div{
            margin-top:20px;
            font-size:15px;
            line-height:1.6;
            color:#5c5c62;
            &.tips{
              color:#a983e5!important
            }
          }
        }
      }
    }
    .container {
      width: 100%;
      min-width: 1200px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .logo-box {
        width: 100%;
        padding-top: 107px;
        .logo {
          width: 153px;
          height: 153px;
          background: url("../assets/logo.png") no-repeat;
          background-size: 100%;
          margin: 0 auto;
        }
        h2 {
          font-size: 36px;
          margin-top: 30px;
          color: #333;
        }
        p {
          font-size: 20px;
          color: #999;
          margin-top: 10px;
        }
      }
      .img1 {
        width: 1200px;
        height: 900px;
        margin-top: 140px;
        display: flex;
        align-items: center;
        .left {
          margin-right: 152px;
          display: flex;
          flex-direction: column;
          .left-title {
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            font-size: 50px;
            margin-top: 86px;
            text-align: left;
          }
          p {
            margin-top: 69px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 48px;
            font-size: 30px;
            text-align: left;
            width: 628px;
          }
        }
        .phone1 {
          height: 100%;
          width: 406px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .line {
        width: 120px;
        height: 6px;
        background: #f3c33d;
        border-radius: 3px;
        margin-top: 26px;
      }
      .img2 {
        width: 1200px;
        height: 900px;
        margin-top: 65px;
        display: flex;
        align-items: center;
        .phone2 {
          height: 100%;
          width: 407px;
          margin-right: 146px;

          img {
            width: 100%;
            height: 100%;
          }
        }
        .right {
          display: flex;
          flex-direction: column;
          .right-title {
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            font-size: 50px;
            margin-top: 162px;
            text-align: left;
          }
          p {
            margin-top: 69px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 48px;
            font-size: 30px;
            text-align: left;
          }
        }
      }
      .img3 {
        width: 100%;
        height: 702px;
        margin-top: 138px;
        /*background: url("../assets/img3.png") no-repeat;
                                                                                                            background-size: 100%;*/
        display: flex;
        /*justify-content: space-between;*/
        .left {
          margin-right: 152px;
          display: flex;
          flex-direction: column;
          .left-title {
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            font-size: 50px;
            margin-top: 86px;
            text-align: left;
          }
          p {
            margin-top: 69px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 48px;
            font-size: 30px;
            text-align: left;
            width: 628px;
          }
        }
      }
    }
    .home-banner {
      width: 100%;
      min-width: 1200px;
      height: 900px;
      margin-top: 70px;
      position: relative;
      .home_back {
        height: 100%;
        position: absolute;
        top: 0;
      }
      .container {
        position: relative;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .content {
          display: flex;
          align-items: center;
          .phone {
            width: 394px;
            height: 880px;

            margin-right: 150px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .right {
            color: #fff;
            text-align: left;
            .header {
              font-weight: 600;
              font-size: 80px;
              //line-height: 38px;
            }
            .hint {
              font-size: 36px;
              margin-top: 29px;
            }
            .btn {
              width: 330px;
              height: 100px;
              border: 3px solid #fff;
              font-size: 40px;
              font-weight: 500;
              line-height: 94px;
              text-align: center;
              border-radius: 50px;
              margin-top: 56px;
              color: #fff;
              padding: 0;
              &:hover {
                color: #fff;
              }
            }
          }
        }
      }
    }
    .nav-header {
      height: 70px;
      width: 100%;
      position: fixed;
      top: 0;
      display: flex;
      justify-content: center;
      background: #fff;
      color: #333333;
      z-index: 9;
      .container {
        width: 1200px;
      }
      .nav {
        width: 100%;
        height: 70px;
        display: flex;
        align-items: center;
        .logo {
          display: flex;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            margin-right: 7px;
          }
          .title {
            h1 {
              display: inline-block;
              color: #000;
              font-weight: bold;
              font-size: 26px;
              margin-right: 13px;
            }
            span {
              display: inline-block;
              color: #999999;
              font-size: 18px;
            }
          }
        }
        .nav-item {
          cursor: pointer;
          text-align: center;
          height: 70px;
          line-height: 70px;
          font-size: 18px;
          display: flex;
          align-items: center;
          position: relative;
          padding: 0 30px;
          color: #333;
          -webkit-touch-callout: none; /* iOS Safari */
          -webkit-user-select: none; /* Chrome/Safari/Opera */
          -khtml-user-select: none; /* Konqueror */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently not supported by any browser */
          text-decoration: none;
          &:hover {
            // color: #f3c33d;
          }
          span {
            cursor: pointer;
            padding-top: 5px;
            &.actived {
              // color: #f3c33d;
              color:#3754fe;
              position: relative;
              &::after{
                content:"";
                height:5px;
                width:30px;
                position: absolute;
                bottom:15px;
                left:50%;
                transform: translateX(-50%);
                background: #3754fe;
              }
            }
          }
          .sanjiao {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            height: 11px;
            width: 29px;
            // background: url("../assets/img1.png") no-repeat;
            background-size: 100%;
          }
        }
      }
    }
    .home_icon {
      width: 100%;
      min-width: 1200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 194px;
        height: 194px;
        margin-top: 105px;
      }
    }
    .message {
      margin-top: 114px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(37, 42, 52, 1);
      height: 140px;
      .item {
        text-align: center;
        margin-right: 100px;
        .privacy {
          color: #ffffff;
          font-size: 20px;
          text-decoration: underline;
          cursor: pointer;
        }
        &:last-child {
          margin-right: 0;
        }
        h3 {
          font-size: 24px;
          color: #fff;
          font-weight: 500;
        }
        p {
          font-size: 18px;
          color: #fff;
          margin-top: 17px;
        }
      }
    }
  }
  .downloadApp{
    font-size:25px;
    padding:5px 10px;
    border-radius:5px;
    color:#fff;
    background:#02cf68;
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/components/HelloWorld.vue